import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BookOfShadowsGameConfig} from "../BookOfShadowsGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";

export class BookOfShadowsNearWinView extends BaseView {
    private _animatingItem: TimelineSprite;
    private _softRedItem: PIXI.Sprite;
    private _cursedAnim: PIXI.spine.Spine;

    private _anticipationAnimStarted: boolean = false;

    /**
     * @description To play the animation.
     * @param reelId
     */
    public playAnimation(reelId: number): void {
        const pos: number[] = Helper.getSymbolPositions(reelId, 0);

        this.stopAllAnimations();

        this._anticipationAnimStarted = true;
        this._softRedItem.position.set(pos[0], pos[1]);
        this._animatingItem.position.set(pos[0], pos[1]);

        this._softRedItem.visible = true;
        this._animatingItem.visible = true;
        this._animatingItem.playLoop();
    }

    /**
     * @description To stop all the animations.
     */
    public stopAllAnimations(): void {
        this._softRedItem.visible = false;

        this._animatingItem.visible = false;
        this._animatingItem.stopLoop();
    }

    /**
     * @description To play the curse animation.
     */
    public playCursedAnim(): void {
        if (!this._anticipationAnimStarted) {
            return;
        }

        this._cursedAnim.renderable = true;
        const tween: SpineTween = new SpineTween(this._cursedAnim, 0, "animation", 0, 1);

        TweenLite.delayedCall(tween.duration(), () => this._cursedAnim.renderable = false);
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        const animatingItemLayer: ScalableLayer = StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.NEAR_WIN.name),
            cursedLayer: ScalableLayer = StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.FREESPIN_COUNTERS.name),
            softRedLayer: ScalableLayer = StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.REEL_ATTENTION.name);

        this._animatingItem = new TimelineSprite(GameResources.getTextures("reelAnticipation"));
        this._animatingItem.visible = false;
        this._animatingItem.blendMode = PIXI.BLEND_MODES.ADD;
        this._animatingItem.anchor.set(0.5, 0.1);
        this._animatingItem.height -= 8;

        this._softRedItem = new PIXI.Sprite(GameResources.getTextures("SoftRedGlow")[0]);
        this._softRedItem.visible = false;
        this._softRedItem.blendMode = PIXI.BLEND_MODES.ADD;
        this._softRedItem.scale.set(2);
        this._softRedItem.anchor.set(0.5, 0.1);

        this._cursedAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("cursed"));
        this._cursedAnim.renderable = false;
        this._cursedAnim.scale.set(2);
        this._cursedAnim.position.set(BookOfShadowsGameConfig.instance.REEL_AREA_WIDTH / 2, BookOfShadowsGameConfig.instance.REEL_AREA_HEIGHT / 2 + BookOfShadowsGameConfig.instance.REEL_AREA_POS_Y);

        softRedLayer.addChild(this._softRedItem);
        animatingItemLayer.addChild(this._animatingItem);
        cursedLayer.addChild(this._cursedAnim);
    }

    /**
     * @inheritDoc
     */
    protected addEventListeners(): void {
        super.addEventListeners && super.addEventListeners();

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, () => this._anticipationAnimStarted = false);
    }
}